import React from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  title?: string | React.ReactNode;
  rightSide?: React.ReactNode;
  afterTitle?: React.ReactNode;
  children?: React.ReactNode;
};

const Header: React.FunctionComponent<Props> = ({
  title = '',
  rightSide,
  children,
  afterTitle,
}) => {
  const navigate = useNavigate();

  const back = () => {
    navigate(-1);
  };

  return (
    <div className="pl-4 pr-6 pt-5 pb-4 border-b border-gray-300 dark:border-dark-gray-700 sm:pl-6 bg-white dark:bg-dark-gray-900">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-0">
        <nav className="sm:hidden">
          <div
            onClick={back}
            className="flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out cursor-pointer"
          >
            <svg
              className="shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Back
          </div>
        </nav>
        <div>
          <h1 className="flex-1 text-xl leading-6 font-medium">{title}</h1>
          {afterTitle && <div className="mb-1">{afterTitle}</div>}
        </div>
        <div className="flex space-x-3">{rightSide}</div>
      </div>
      {children}
    </div>
  );
};

export default Header;

// import React from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import Breadcrumbs, { Breadcrumb } from './Breadcrumbs';

// type Props = {
//   breadcrumbs?: Breadcrumb[];
//   title?: string | React.ReactNode;
//   rightSide?: React.ReactNode;
//   afterTitle?: React.ReactNode;
// };

// const Header: React.FunctionComponent<Props> = ({
//   title = '',
//   breadcrumbs,
//   rightSide,
//   children,
//   afterTitle,
// }) => {
//   const navigate = useNavigate();

//   const back = () => {
//     navigate(-1);
//   };

//   return (
//     <div
//       className="pl-4 pr-6 pt-5 pb-4 border-b border-gray-300 dark:border-dark-gray-700 sm:pl-6 bg-white dark:bg-dark-gray-900 items-center flex"
//       style={{ minHeight: 75 }}
//     >
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
//         <div>
//           <nav className="sm:hidden">
//             <div
//               onClick={back}
//               className="flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out cursor-pointer"
//             >
//               <svg
//                 className="shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//               Back
//             </div>
//           </nav>
//           {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
//           <h1 className="flex-1 text-xl leading-6 font-medium">{title}</h1>
//           {afterTitle && <div className="mb-1">{afterTitle}</div>}
//         </div>
//         <div className="flex space-x-3">{rightSide}</div>
//       </div>
//       {children}
//     </div>
//   );
// };

// export default Header;
